// extracted by mini-css-extract-plugin
module.exports = {"root":"RelatedProducts_root__h2nZY","title":"RelatedProducts_title__UEWuo","list":"RelatedProducts_list__ZHlzY"};